<template>
	<div class="content">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>redeem</md-icon>
					</template>

					<template slot="content">
						<p class="category">ចំនួនកញ្ចប់សរុប</p>
						<h3 class="title">{{stat.total_package}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>redeem</md-icon>
					</template>

					<template slot="content">
						<p class="category">ចំនួនការកក់សរុប</p>
						<h3 class="title">{{stat.total_book}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>groups</md-icon>
					</template>
					<template slot="content">
						<p class="category">ចំនួនអតិថិជនសរុប</p>
						<h3 class="title">{{stat.total_client}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>delivery_dining</md-icon>
					</template>
					<template slot="content">
						<p class="category">ចំនួនអ្នកដឹកជញ្ជូនសរុប</p>
						<h3 class="title">{{stat.total_driver}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>supervised_user_circle</md-icon>
					</template>
					<template slot="content">
						<p class="category">ចំនួនអ្នកគ្រប់គ្រង</p>
						<h3 class="title">{{stat.total_admin}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>map</md-icon>
					</template>
					<template slot="content">
						<p class="category">ចំនួនតំបន់សរុប</p>
						<h3 class="title">{{stat.total_zone}}</h3>
					</template>
				</stats-card>
			</div>

			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>place</md-icon>
					</template>
					<template slot="content">
						<p class="category">ចំនួនទីតាំងសរុប</p>
						<h3 class="title">{{stat.total_location}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>category</md-icon>
					</template>
					<template slot="content">
						<p class="category">ចំនួនប្រភេទកញ្ចប់រសុប</p>
						<h3 class="title">{{stat.total_package_type}}</h3>
					</template>
				</stats-card>
			</div>
			<template v-if="allow_user('sa')">
				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
					<h3>ទឹកប្រាក់មិនទាន់ទូទាត់</h3>
				</div>

				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់មិនទាន់ទូទាត់ឲ្យអតិថិជន</p>
							<h3 class="title">{{config.moneylify(stat.unpaid_client_usd)}} និង {{config.moneylify(stat.unpaid_client_khr, 'khr')}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ត្រូវប្រមូលពីអតិថិជន</p>
							<h3 class="title">{{config.moneylify(stat.unpaid_fee_usd)}} និង {{config.moneylify(stat.unpaid_fee_khr, 'khr')}}</h3>
						</template>
					</stats-card>
				</div>

				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់មិនទាន់ទូទាត់ឲ្យការិយាល័យ</p>
							<h3 class="title">{{config.moneylify(stat.unpaid_office, 'khr')}}</b></h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់មិនទាន់ទូទាត់ឲ្យអ្នកដឹកជញ្ជូន</p>
							<h3 class="title">{{config.moneylify(stat.unpaid_driver_fee, 'khr')}}</b></h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់មិនទាន់ទូទាត់ឲ្យអ្នកទៅទទួលកញ្ចប់ឥវ៉ាន់</p>
							<h3 class="title">{{config.moneylify(stat.unpaid_pickup_fee, 'khr')}}</b></h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់មិនទាន់ទូទាត់ឲ្យអ្នកទីផ្សារ</p>
							<h3 class="title">{{config.moneylify(stat.unpaid_referral, 'khr')}}</b></h3>
						</template>
					</stats-card>
				</div>
			</template>

			<template v-if="allow_user('sa')">
				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
					<h3>ថ្ងៃនេះ</h3>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>redeem</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនកញ្ចប់សរុប</p>
							<h3 class="title">{{today.total_package}} / <b>{{today.total_pending_package}}</b></h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>redeem</md-icon>
						</template>

						<template slot="content">
							<p class="category">ចំនួនការកក់សរុប</p>
							<h3 class="title">{{today.total_book}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ថ្លៃដឹកជញ្ញូនសរុប</p>
							<h3 class="title">{{config.moneylify(today.total_fee_usd)}} និង
								{{config.moneylify(today.total_fee_khr, 'khr')}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ថ្លៃទូទាត់អ្នកដឹកជញ្ជូនសរុប</p>
							<h3 class="title">{{config.moneylify(today.total_driver_fee_usd)}} និង
								{{config.moneylify(today.total_driver_fee_khr, 'khr')}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំណេញសរុប</p>
							<h3 class="title">{{config.moneylify(today.total_fee_usd - today.total_driver_fee_usd)}} និង
								{{config.moneylify(today.total_fee_khr - today.total_driver_fee_khr, 'khr')}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំណូលសរុប</p>
							<h3 class="title">{{config.moneylify(today.total_deposit_usd)}} និង
								{{config.moneylify(today.total_deposit_khr,'khr')}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំណាយសរុប</p>
							<h3 class="title">{{config.moneylify(today.total_wit_usd)}} និង
								{{config.moneylify(today.total_wit_khr, 'khr')}}</h3>
						</template>
					</stats-card>
				</div>

			</template>
			<!-- <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>attach_money</md-icon>
					</template>
					<template slot="content">
						<p class="category">ប្រាក់ចំណេញ</p>
						<h3 class="title">{{config.moneylify(today.total_deposit_usd - today.total_wit_usd)}}</h3>
					</template>
				</stats-card>
			</div> -->
			<template v-if="allow_user('sa')">
				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
					<h3>ខែនេះ</h3>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>redeem</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនកញ្ចប់សរុប</p>
							<h3 class="title">{{month.total_package}} / <b>{{month.total_pending_package}}</b></h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>redeem</md-icon>
						</template>

						<template slot="content">
							<p class="category">ចំនួនការកក់សរុប</p>
							<h3 class="title">{{month.total_book}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ថ្លៃដឹកជញ្ញូនសរុប</p>
							<h3 class="title">{{config.moneylify(month.total_fee_usd)}} និង
								{{config.moneylify(month.total_fee_khr, 'khr')}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ថ្លៃទូទាត់អ្នកដឹកជញ្ជូនសរុប</p>
							<h3 class="title">{{config.moneylify(month.total_driver_fee_usd)}} និង
								{{config.moneylify(month.total_driver_fee_khr, 'khr')}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំណេញសរុប</p>
							<h3 class="title">{{config.moneylify(month.total_fee_usd - month.total_driver_fee_usd)}} និង
								{{config.moneylify(month.total_fee_khr - month.total_driver_fee_khr, 'khr')}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំណូលសរុប</p>
							<h3 class="title">{{config.moneylify(month.total_deposit_usd)}} និង
								{{config.moneylify(month.total_deposit_khr,'khr')}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>attach_money</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំណាយសរុប</p>
							<h3 class="title">{{config.moneylify(month.total_wit_usd)}} និង
								{{config.moneylify(month.total_wit_khr, 'khr')}}</h3>
						</template>
					</stats-card>
				</div>

			</template>

			<template v-if="allow_user('sa')">
				<md-card>
					<md-card-header data-background-color="orange">
						<h4>ស្វែងរកទិន្នន័យ</h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-field>
									<label>ថ្ងៃចាប់ផ្តើម</label>
									<md-input type="text" v-model="start_date" style="display:none" />
									<datetime type="datetime" v-model="start_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">

								<md-field>
									<label>ថ្ងៃបញ្ចប់</label>
									<md-input type="text" v-model="end_date" style="display:none" />
									<datetime type="datetime" v-model="end_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-button class="md-raised md-primary" style="width:100%" @click="getRange()">បង្ហាញ
								</md-button>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>redeem</md-icon>
									</template>
									<template slot="content">
										<p class="category">ចំនួនកញ្ចប់សរុប</p>
										<h3 class="title">{{range.total_package}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>redeem</md-icon>
									</template>

									<template slot="content">
										<p class="category">ចំនួនការកក់សរុប</p>
										<h3 class="title">{{range.total_book}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>attach_money</md-icon>
									</template>
									<template slot="content">
										<p class="category">ថ្លៃដឹកជញ្ញូនសរុប</p>
										<h3 class="title">{{config.moneylify(range.total_fee_usd)}} និង
											{{config.moneylify(range.total_fee_khr, 'khr')}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>attach_money</md-icon>
									</template>
									<template slot="content">
										<p class="category">ថ្លៃទូទាត់អ្នកដឹកជញ្ជូនសរុប</p>
										<h3 class="title">{{config.moneylify(range.total_driver_fee_usd)}} និង
											{{config.moneylify(range.total_driver_fee_khr, 'khr')}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>attach_money</md-icon>
									</template>
									<template slot="content">
										<p class="category">ចំណេញសរុប</p>
										<h3 class="title">{{config.moneylify(range.total_fee_usd - range.total_driver_fee_usd)}} និង
											{{config.moneylify(range.total_fee_khr - range.total_driver_fee_khr, 'khr')}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>attach_money</md-icon>
									</template>
									<template slot="content">
										<p class="category">ចំណូលសរុប</p>
										<h3 class="title">{{config.moneylify(range.total_deposit_usd)}} និង
											{{config.moneylify(range.total_deposit_khr,'khr')}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>attach_money</md-icon>
									</template>
									<template slot="content">
										<p class="category">ចំណាយសរុប</p>
										<h3 class="title">{{config.moneylify(range.total_wit_usd)}} និង
											{{config.moneylify(range.total_wit_khr, 'khr')}}</h3>
									</template>
								</stats-card>
							</div>
						</div>
					</md-card-content>
				</md-card>

			</template>

		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'
	import { Datetime } from 'vue-datetime';
	import {
		NewMember
	} from '@/pages/Dashboard/index'

	export default {
		components: {
			StatsCard,
			NewMember,
			Datetime
		},
		mounted() {
			if (this.$store.state.authentication.account_type == 'ca') {
				this.$router.push('/new_package');
			}
			if (this.$store.state.authentication.account_type == 'ac') {
				this.$router.push('/accountant_payments');
			}
			if (this.$store.state.authentication.account_type == 'sl') {
				this.$router.push('/payments');
			}
			if (this.$store.state.authentication.account_type == 'da') {
				this.$router.push('/payments');
			}
			if (this.$store.state.authentication.account_type == 'ad') {
				this.$router.push('/booking');
			}
			if (this.$store.state.authentication.mode == 'driver') {
				this.$router.push('/driver_packages');
			}
			if (this.$store.state.authentication.mode == 'scanner') {
				this.$router.push('/scanner');
			}
		},
		created() {
			this.$http.get(this.config.api + "/admin/get/stat").then(data => {
				this.stat = data.body.data
				this.loaded = true;
			});
			this.getToday();
			this.getMonth();
		},
		methods: {
			getToday() {
				this.$http.get(this.config.api + "/admin/get/stat/day").then(data => {
					this.today = data.body.data
				});
			},
			getMonth() {
				this.$http.get(this.config.api + "/admin/get/stat/month").then(data => {
					this.month = data.body.data
				});
			},
			getRange() {
				let start_date = (new Date(this.start_date)).getTime();
				let end_date = (new Date(this.end_date)).getTime();

				this.$http.get(this.config.api + "/admin/get/stat/range/" + start_date + "/" + end_date).then(data => {
					this.range = data.body.data
					// this.loaded = true;
				});
			}
		},
		computed: {
		},
		data() {
			return {
				loaded: false,
				stat: {
					total_admin: 0,
					total_package: 0,
					total_book: 0,
					total_driver: 0,
					total_client: 0,
					total_zone: 0,
					total_location: 0,
					total_package_type: 0,
					unpaid_office: 0,
					unpaid_referral: 0,
					unpaid_pickup_fee: 0,
					unpaid_driver_fee: 0,
					unpaid_client_khr: 0,
					unpaid_client_usd: 0,
					unpaid_fee_khr: 0,
					unpaid_fee_usd: 0
				},
				today: {
					total_pending_package: 0,
					total_package: 0,
					total_book: 0,
					total_deposit_khr: 0,
					total_deposit_usd: 0,
					total_wit_usd: 0,
					total_wit_khr: 0,
					total_fee_usd: 0,
					total_fee_khr: 0,
					total_driver_fee_usd: 0,
					total_driver_fee_khr: 0
				},
				month: {
					total_pending_package: 0,
					total_package: 0,
					total_book: 0,
					total_deposit_khr: 0,
					total_deposit_usd: 0,
					total_wit_usd: 0,
					total_wit_khr: 0,
					total_fee_usd: 0,
					total_fee_khr: 0,
					total_driver_fee_usd: 0,
					total_driver_fee_khr: 0
				},
				start_date: "",
				end_date: "",
				range: {
					total_pending_package: 0,
					total_package: 0,
					total_book: 0,
					total_deposit_khr: 0,
					total_deposit_usd: 0,
					total_wit_usd: 0,
					total_wit_khr: 0,
					total_fee_usd: 0,
					total_fee_khr: 0,
					total_driver_fee_usd: 0,
					total_driver_fee_khr: 0
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue